export default "__VITE_ASSET__DQuB3Cuz__"